(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    
    // === BUY BUTTON - ADD TO CART + GO TO CART PAGE ===
    document.querySelectorAll('.product-buy-btn').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const variantId = this.getAttribute('data-variant-id');
        
        if (!variantId || this.disabled) return;
        
        this.disabled = true;
        const originalText = this.innerHTML;
        this.innerHTML = '<span style="display:inline-block;animation:spin 0.6s linear infinite;border:2px solid rgba(255,255,255,0.3);border-top-color:#fff;border-radius:50%;width:14px;height:14px;"></span> Adding...';
        
        // Add to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId),
              quantity: 1
            }]
          })
        })
        .then(res => res.json())
        .then(data => {
          // Go to cart page
          window.location.href = 'https://www.barrelbloomok.ca/cart';
        })
        .catch(err => {
          console.error('Cart error:', err);
          this.disabled = false;
          this.innerHTML = originalText;
          alert('Error adding to cart. Please try again.');
        });
      });
    });

    // === PRODUCT IMAGE - ADD TO CART + GO TO CART PAGE ===
    document.querySelectorAll('.link-image').forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Find the variant ID from the buy button in the same card
        const card = this.closest('.card-product');
        const buyButton = card.querySelector('.product-buy-btn');
        const variantId = buyButton.getAttribute('data-variant-id');
        
        if (!variantId) {
          // If no variant ID, just go to product page
          window.location.href = this.href;
          return;
        }
        
        // Add to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId),
              quantity: 1
            }]
          })
        })
        .then(res => res.json())
        .then(data => {
          // Go to cart page
          window.location.href = 'https://www.barrelbloomok.ca/cart';
        })
        .catch(err => {
          console.error('Cart error:', err);
          // On error, go to product page
          window.location.href = this.href;
        });
      });
    });

    // === CART ICON - REDIRECT TO CUSTOM CHECKOUT ===
    // This will work for all cart icons/links on the page
    document.addEventListener('click', function(e) {
      // Check if clicked element is a cart link/icon
      const cartLink = e.target.closest('a[href="/cart"], a[href*="/cart"]');
      
      if (cartLink && !cartLink.classList.contains('link-image')) {
        e.preventDefault();
        window.location.href = 'https://www.barrelbloomok.ca/checkouts/cn/hWN7gvads6PxO6yKoyi5tmwT/en-ca?_r=AQABBz_ES_7qjQpyC8J6PbbdBG2L5SrTruKMC2KG8QOizew&adminUrl=admin.shopify.com&cart_link_id=sXHsLfeK&editedAt=2026-01-06T15%3A33%3A34Z&isPublished=true&preview_theme_id=185971736859&profileName=stefanie+configuration&profile_preview_token=eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ5N3d3aXMtMXkubXlzaG9waWZ5LmNvbSIsImF1ZCI6Ink3d3dpcy0xeS5teXNob3BpZnkuY29tIiwibmJmIjoxNzY4NjA4NzQ3LCJjaGVja291dF9wcm9maWxlX2lkIjo3MDQzODQyMzMxLCJjaGVja291dF9wcm9maWxlX3B1Ymxpc2hlZCI6dHJ1ZSwidXNlcl9pZCI6MTI1MTQ4NTk0NDU5LCJleHAiOjE3Njg2MTIzNDd9.W326WD3PdUTuG84_sTTZr8ku4vru74rRUH6XCuXkH6k';
      }
    });

    // === FILTER TOGGLE ===
    document.querySelectorAll('.filter-header').forEach(header => {
      header.addEventListener('click', function(e) {
        e.preventDefault();
        this.classList.toggle('active');
        const content = this.nextElementSibling;
        
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });

    // === MOBILE FILTER ===
    const filterToggle = document.querySelector('.mobile-filter-toggle');
    const filterSidebar = document.querySelector('.filters-sidebar');
    const filterClose = document.querySelector('.filter-close');
    const filterOverlay = document.querySelector('.filter-overlay');

    if (filterToggle) {
      filterToggle.addEventListener('click', () => {
        filterSidebar.classList.add('active');
        filterOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    }

    [filterClose, filterOverlay].forEach(el => {
      if (el) {
        el.addEventListener('click', () => {
          filterSidebar.classList.remove('active');
          filterOverlay.classList.remove('active');
          document.body.style.overflow = '';
        });
      }
    });

    // === PRICE FILTER ===
    document.querySelectorAll('input[name="price_range"]').forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.checked) {
          const [min, max] = this.value.split('-');
          applyPriceFilter(min, max || '999999');
        }
      });
    });

    const priceFrom = document.querySelector('input[name="price_from"]');
    const priceTo = document.querySelector('input[name="price_to"]');
    
    if (priceFrom && priceTo) {
      const priceInputsDiv = priceFrom.closest('.price-inputs');
      if (priceInputsDiv && !priceInputsDiv.querySelector('.apply-price-btn')) {
        const applyBtn = document.createElement('button');
        applyBtn.type = 'button';
        applyBtn.className = 'apply-price-btn';
        applyBtn.textContent = 'Apply';
        priceInputsDiv.appendChild(applyBtn);
        
        applyBtn.addEventListener('click', () => {
          const min = priceFrom.value || '0';
          const max = priceTo.value || '999999';
          applyPriceFilter(min, max);
        });
      }
    }

    function applyPriceFilter(min, max) {
      const url = new URL(window.location.href);
      url.searchParams.set('filter.v.price.gte', min);
      url.searchParams.set('filter.v.price.lte', max);
      window.location.href = url.toString();
    }

    // === AVAILABILITY FILTER ===
    document.querySelectorAll('input[name="availability"]').forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        const url = new URL(window.location.href);
        const allChecked = Array.from(document.querySelectorAll('input[name="availability"]:checked'));
        
        if (allChecked.length > 0) {
          url.searchParams.set('filter.v.availability', this.value);
        } else {
          url.searchParams.delete('filter.v.availability');
        }
        
        window.location.href = url.toString();
      });
    });

    // === PRODUCT TYPE FILTER ===
    document.querySelectorAll('input[name="product_type"]').forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        const url = new URL(window.location.href);
        
        if (this.checked) {
          url.searchParams.set('filter.p.product_type', this.value);
          document.querySelectorAll('input[name="product_type"]').forEach(cb => {
            if (cb !== this) cb.checked = false;
          });
        } else {
          url.searchParams.delete('filter.p.product_type');
        }
        
        window.location.href = url.toString();
      });
    });

    // === VENDOR FILTER ===
    document.querySelectorAll('input[name="vendor"]').forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        const url = new URL(window.location.href);
        
        if (this.checked) {
          url.searchParams.set('filter.p.vendor', this.value);
          document.querySelectorAll('input[name="vendor"]').forEach(cb => {
            if (cb !== this) cb.checked = false;
          });
        } else {
          url.searchParams.delete('filter.p.vendor');
        }
        
        window.location.href = url.toString();
      });
    });

    // === CLEAR FILTERS ===
    const clearBtn = document.querySelector('.clear-filters');
    if (clearBtn) {
      clearBtn.addEventListener('click', (e) => {
        e.preventDefault();
        window.location.href = window.location.pathname;
      });
    }

    // === BACK BUTTON ===
    const backBtn = document.querySelector('.back-to-home');
    if (backBtn) {
      backBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = '/';
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
